import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';
import { decrement, increment, removeProductFromCart, setToLocalStorage } from '../../../store/UserSlice';
import './quantityBlock.scss';

interface IQuantityBlockProps {
    id: string;
    disableDecrement?: boolean;
    background?: string;
}

const QuantityBlock: React.FC<IQuantityBlockProps> = ({ id, disableDecrement = false, background = '#fff' }) => {
    const dispatch = useDispatch<AppDispatch>();
    const { cart } = useSelector((state: RootState) => state.user);
    const productInCart = cart.find((cartItem) => cartItem.productId === id);
    const isDisabled = disableDecrement && productInCart?.quantity === 1;

    const incrementHandler = () => {
        dispatch(increment(id));
        dispatch(setToLocalStorage('cart'));
    };

    const decrementHandler = () => {
        dispatch(decrement(id));
        dispatch(setToLocalStorage('cart'));
        if (productInCart?.quantity === 1) {
            dispatch(removeProductFromCart(id));
            dispatch(setToLocalStorage('cart'));
            return;
        }
    };

    return (
        <div className="quantityBlock" style={{ backgroundColor: background }}>
            <button
                className="quantityBlock__button quantityBlock__button--left"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    decrementHandler();
                }}
                disabled={isDisabled}
            >
                <span className="quantityBlock__button_text">–</span>
            </button>
            <span className="quantityBlock__quantity">{productInCart?.quantity || 1}</span>
            <button
                className="quantityBlock__button quantityBlock__button--right"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    incrementHandler();
                }}
            >
                <span className="quantityBlock__button_text">+</span>
            </button>
        </div>
    );
};

export default QuantityBlock;
